<div class="wrapper fadeInDown">
    <div id="formContent">
        <div class="otptext">
            <!-- <ng-otp-input [config]="{length:4}" allowNumbersOnly="true"></ng-otp-input> -->
            <p>{{timeLeft}} Seconds Left....</p>
            <div class="otpbutton" *ngIf="showResendFlag==true" (click)="startTimer()"><button class="btn btn-primary">Resend OTP</button></div>
        </div>
    </div>
</div>